import { Box, styled, Typography } from '@mui/material';

export const CellContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'start',
  gap: 1,
});

export const CellTypography = styled(Typography)({
  p: 0,
  m: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
});
